export default __webpack_public_path__ + "static/media/icon-certificate.12564454.svg";